import { Select, SelectChangeEvent, SvgIcon } from '@mui/material';
import styles from '../../../CreateMemorialQuiltStepThree/styles.module.scss';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import { TypeImageEnum } from '../../../CreateMemorialQuiltStepThree/const';
import Cropper from 'cropperjs';
import { ImageTypeModel } from '../../../CreateMemorialQuiltStepThree/model';
import { useCallback } from 'react';
import { getSelectOptions } from 'utilities';
import { useTranslates } from 'providers/translates';

type Props = {
  isAddImagesOnly: boolean | undefined;
  onSetShowClearImagesDialog: () => void;
  isStepOne: boolean | undefined;
  currentCrop: Cropper | null;
  aspectRatio: TypeImageEnum;
  changeCurrentFileImageType:(event: SelectChangeEvent<TypeImageEnum>) => void;
  currentFileImage: File | null | undefined;
  changeImage: () => void;
  onSetImageBlock: (image: ImageTypeModel | null) => void;
  originalImage: string | null;
  cancelImage: () => void;
};

const EditorBlockBottom: React.FC<Props> = ({
  isAddImagesOnly,
  onSetShowClearImagesDialog,
  isStepOne,
  currentCrop,
  aspectRatio,
  changeCurrentFileImageType,
  changeImage,
  onSetImageBlock,
  originalImage,
  cancelImage,
  currentFileImage
}) => {
  const { translates: t } = useTranslates();
  const addAPhoto = t?.quiltBuilderStepOne?.addAPhoto;
  const builderThreeAddPhotosSection = t?.quiltBuilderStepThree?.builderThreeAddPhotosSection;

  const optionsTypeImages = [
    { value: TypeImageEnum.PORTRAIT, label: builderThreeAddPhotosSection?.portraitCropButtonLabel ?? 'Portrait' },
    { value: TypeImageEnum.LANDSCAPE, label: builderThreeAddPhotosSection?.landscapeCropButtonLabel ?? 'Landscape' },
    { value: TypeImageEnum.SQUARE, label: builderThreeAddPhotosSection?.squareCropButtonLabel ?? 'Square' },
  ];

  // select
  const getOptionsTypeImages = useCallback(
    (typeImage: string) => {
      return getSelectOptions(optionsTypeImages, typeImage);
    },
    [currentFileImage]
  );

  const rotateImage = () => {
    currentCrop && currentCrop.rotate(45);
  };

  const continueImage = () => {
    if (!currentCrop) return;

    onSetImageBlock({
      file: currentCrop.getCroppedCanvas().toDataURL('image/png'),
      type: aspectRatio,
      originalImage: originalImage ?? '',
    });

    changeImage();
  };

  return (
    !isAddImagesOnly ? (
      <div className={styles.editorBlock1__bottom}>
        <div className={`${styles.editorBlock1__bottomButtonLeft} ${styles.isDesktop}`}>
          <button
            className={`${styles.editorBlock1__button}`}
            style={{
              color: '#d85656',
            }}
            onClick={onSetShowClearImagesDialog}
          >
            {addAPhoto?.clearAlbumButtonText ?? 'clear album'}
          </button>
        </div>
        <div className={styles.editorBlock1__bottomButtonRight}>
          <div
            className={`${styles.editorBlock1__bottomButton_choice} ${isStepOne ? '' : styles.column_reverse}`}
          >
            <div className={styles.rotateAndSelectWrapper}>
              <button
                onClick={rotateImage}
                className={`${styles.editorBlock1__button}`}
                style={{
                  padding: '6px 10px 3px',
                }}
              >
                <SettingsBackupRestoreIcon
                  className={`${styles.editorBlock1__bottomSvg}`}
                />
              </button>
              {!isStepOne && (
                <Select
                  className="customSelect"
                  inputProps={{
                    sx: {
                      background: 'white',
                      padding: '5px 15px',
                      fontSize: '20px !important',
                    },
                  }}
                  sx={{
                    minWidth: { xs: 'auto', sm: 200 },
                    minHeight: 39,
                    fieldset: {
                      border: '1px solid #26a3c5',
                    },
                    "& .MuiSelect-icon": {
                      fontSize: "2rem",
                    },
                  }}
                  MenuProps={{
                    className: 'customSelectMenu',
                  }}
                  value={aspectRatio}
                  onChange={changeCurrentFileImageType}
                >
                  {getOptionsTypeImages(aspectRatio || '')}
                </Select>
              )}
            </div>
            <button 
              className={`${styles.editorBlock1__button}`} 
              onClick={changeImage}
            >
              {addAPhoto?.clearAlbumButtonText ?? 'Clear image'}
            </button>
          </div>
          <div className={styles.editorBlock1__bottomButton}>
            <button 
              className={`${styles.editorBlock1__button}`} 
              onClick={cancelImage}
            >
              {t?.buttonsForTheSite?.cancel ?? 'Cancel'}
            </button>
            <button 
              className={`${styles.editorBlock1__button}`} 
              onClick={continueImage}
            >
              {addAPhoto?.saveButtonText ?? 'Save'}
            </button>
          </div>
        </div>
      </div>
    ) : (
      <></>
    )
  );
}

export { EditorBlockBottom };
